import { render } from "./PortfolioSection.vue?vue&type=template&id=2b33f63c&ts=true"
import script from "./PortfolioSection.vue?vue&type=script&lang=ts"
export * from "./PortfolioSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__